export default {
  submitApi: 'Preference/Formsubmit',
  marketingUnsubscribe: 'Preference/EmailUnsubscribe',
};
